import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  HStack,
  Text,
  Badge,
  Icon,
  Box,
  Avatar,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaCheck, FaHeart } from 'react-icons/fa';
import { formatDistanceToNow } from 'date-fns';
import { it } from 'date-fns/locale';

export default function MatchDetailsModal({ isOpen, onClose, scambio }) {
  const bg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  if (!scambio || !scambio.matches) {
    return null;
  }

  const availableMatches = scambio.matches.filter((m) => m.type === 'ce-lho');
  const wantedMatches = scambio.matches.filter((m) => m.type === 'mi-serve');

  const renderMatchList = (matches, type, icon, color, title) => {
    if (matches.length === 0) return null;

    return (
      <Box>
        <HStack spacing={2} mb={3}>
          <Icon as={icon} color={`${color}.500`} />
          <Text fontWeight="bold" color={`${color}.600`}>
            {title} ({matches.length})
          </Text>
        </HStack>

        <VStack spacing={3} align="stretch">
          {matches.map((match, index) => (
            <Box
              key={match.id || index}
              p={3}
              border="1px solid"
              borderColor={borderColor}
              borderRadius="md"
              bg={bg}
            >
              <HStack justify="space-between" mb={2}>
                <HStack spacing={2}>
                  <Avatar size="sm" name={match.user?.username || 'Utente'} />
                  <VStack align="start" spacing={0}>
                    <Text fontWeight="semibold">
                      {match.user?.username || 'Utente'}
                    </Text>
                  </VStack>
                </HStack>

                <Badge colorScheme={color} variant="subtle">
                  {formatDistanceToNow(new Date(match.createdAt), {
                    addSuffix: true,
                    locale: it,
                  })}
                </Badge>
              </HStack>

              {match.note && (
                <Text fontSize="sm" color="gray.600" mt={2}>
                  &ldquo;{match.note}&rdquo;
                </Text>
              )}
            </Box>
          ))}
        </VStack>
      </Box>
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack spacing={3}>
            <Icon as={FaCheck} color="green.500" />
            <Text>Dettagli Match - {scambio.carte?.nome || 'Carta'}</Text>
          </HStack>
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody pb={6}>
          <VStack spacing={6} align="stretch">
            {/* Info carta */}
            <Box p={4} bg="blue.50" borderRadius="md">
              <Text fontSize="sm" color="blue.700">
                <strong>Tipo:</strong>{' '}
                {scambio.tipo === 'cerco' ? '📥 Cerca' : '🎁 Offre'}
              </Text>
              <Text fontSize="sm" color="blue.700">
                <strong>Stato:</strong> {scambio.stato}
              </Text>
              <Text fontSize="sm" color="blue.700">
                <strong>Creato:</strong>{' '}
                {formatDistanceToNow(new Date(scambio.createdAt), {
                  addSuffix: true,
                  locale: it,
                })}
              </Text>
            </Box>

            {/* Match disponibili */}
            {renderMatchList(
              availableMatches,
              'ce-lho',
              FaCheck,
              'green',
              'Persone che hanno questa carta'
            )}

            {/* Match interessati */}
            {renderMatchList(
              wantedMatches,
              'mi-serve',
              FaHeart,
              'pink',
              'Persone interessate a questa carta'
            )}

            {availableMatches.length === 0 && wantedMatches.length === 0 && (
              <Box textAlign="center" py={8}>
                <Text color="gray.500">
                  Ancora nessun match per questa carta.
                </Text>
                <Text fontSize="sm" color="gray.400" mt={2}>
                  Usa i pulsanti &ldquo;Ce L&apos;ho!&rdquo; o &ldquo;Mi
                  serve!&rdquo; per creare il primo match!
                </Text>
              </Box>
            )}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
